import { render, staticRenderFns } from "./patientConsultation.vue?vue&type=template&id=e9157c72&"
import script from "./patientConsultation.vue?vue&type=script&lang=js&"
export * from "./patientConsultation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports